<template>
    <div class="popup profile-wrap">
        <vue-headful :title="title" :description="title"/>
        <div class="title"> {{ title }}
            <div class="close">
                <router-link v-if="!$store.state.status" to="/">
                    <img src="/img/profile/close-x.svg"/>
                </router-link>
                <!--<router-link v-else to="/profiles?">-->  <!--<img src="/img/profile/close-x.svg"/>-->
                <!--</router-link>-->
                <a v-else @click="s"> <img src="/img/profile/close-x.svg"/> </a>
            </div>
        </div>
        <hr class="hr"/>
        <div class="popup-body">
            <div style="margin: 15px">
                <img style="width: 100px;" :src="'/img/profile/' + (icon ? icon : 'success.svg')"/>
            </div>
            <div v-html="desc"></div>
            <router-link v-if="btn && btn.url" :to="btn.url" class="btn btn-success btn-blue popup-success-btn">
                {{ btn.title }}
            </router-link>
            <div v-else-if="btn && btn.popup" class="btn btn-success btn-blue popup-success-btn" @click="$store.state.popup=btn.popup">
                {{btn.title}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["title", "desc", "btn", "icon"],
        methods: {
            s() {
                this.$store.state.status = null;
            }
        },
        created() {
            if (!this.btn_link) {
                this.btn_link = "/";
            }
        }
    };
</script>
